export default {"src":"/_next/static/media/calendar_filled.7a54665c.svg","height":50,"width":63,"blurWidth":0,"blurHeight":0};